import script from "./DocumentDownloadLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentDownloadLayout.vue?vue&type=script&setup=true&lang=js"

import "./DocumentDownloadLayout.vue?vue&type=style&index=0&id=0dcbe7d5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dcbe7d5"]])

export default __exports__